<template>
    <div
        :class="[sizeClasses, borderClasses]"
        class="bg-bg relative flex aspect-square shrink-0 items-center justify-center overflow-hidden border"
    >
        <img
            v-avatar-fallback="src"
            :alt="alt || $t('general.avatar_alt')"
            class="h-full min-h-full w-full min-w-full object-cover object-center"
        />
        <div class="avatarBG"></div>
    </div>
</template>

<script>

export default {
    name: 'Avatar',
    props: {
        src: {
            type: String,
            default: null,
        },
        alt: {
            type: String,
            default: '',
        },
        size: {
            type: [String, Number],
            default: 17,
        },
        borderColor: {
            type: String,
            default: 'border-stroke-1',
        },
    },
    computed: {
        sizeClasses() {
            const sizeMap = {
                8: 'size-8',
                9: 'size-9',
                10: 'size-10',
                11: 'size-11',
                12: 'size-12',
                14: 'size-14',
                16: 'size-16',
                17: 'size-17',
                20: 'size-20',
                24: 'size-24',
                40: 'size-40',
                64: 'size-64',
            }
            return sizeMap[this.size] || (this.size ?? 'size-17')
        },
        borderClasses() {
            return this.borderColor
        },
    },
}
</script>
